export default "__VITE_ASSET__AioID1EE__"